import { useWarehouseContext } from "./WarehouseProvider";
import { CapturePackagePhotos } from "./CapturePackagePhotos";
import { CheckContents } from "./CheckContents";
import { ControlWeightCapture } from "./ControlWeightCapture";
import { PackagingWeightCapture } from "./PackagingWeightCapture";
import { ContentWeightCapture } from "./ContentWeightCapture";
import { NonConformPhoto } from "./NonConformPhoto";
import { SortContents } from "./SortContents";
import { AssembledWeightCapture } from "./AssembledWeightCapture";
import { ConformingWeightCapture } from "./ConformingWeightCapture";
import { CaptureScaleReadingPhoto } from "./CaptureScaleReadingPhoto";
import { Summary } from "./Summary";

import { useConfiguration } from "./useConfiguration";

export const useStepsWithData = () => {
  const { isStepValid, isStepVisible } = useConfiguration();
  const {
    packagePictures,
    controlWeight,
    packagingWeight,
    contentWeight,
    nonConformPictures,
    sortedPictures,
    assembledWeight,
    conformingWeight,
    nonConformingWeight,
    scaleReadingPictures,
  } = useWarehouseContext();

  return [
    {
      StepComponent: CapturePackagePhotos,
      details: "Take a photo of the package",
      value: packagePictures,
      completed: isStepValid(CapturePackagePhotos),
      visible: isStepVisible(CapturePackagePhotos),
    },
    {
      StepComponent: CheckContents,
      completed: true,
      visible: isStepVisible(CheckContents),
    },
    {
      StepComponent: ControlWeightCapture,
      details: "Record the control weight",
      value: controlWeight,
      completed: isStepValid(ControlWeightCapture),
      visible: isStepVisible(ControlWeightCapture),
    },
    {
      StepComponent: PackagingWeightCapture,
      details: "Record the packaging weight",
      value: packagingWeight,
      completed: isStepValid(PackagingWeightCapture),
      visible: isStepVisible(PackagingWeightCapture),
    },
    {
      StepComponent: ContentWeightCapture,
      details: "Record the contents weight",
      value: contentWeight,
      completed: isStepValid(ContentWeightCapture),
      visible: isStepVisible(ContentWeightCapture),
    },
    {
      StepComponent: SortContents,
      details: "Sort contents into buckets",
      value: sortedPictures,
      completed: isStepValid(SortContents),
      visible: isStepVisible(SortContents),
    },
    {
      StepComponent: NonConformPhoto,
      details: "Take a photo of non-conforming contents",
      value: nonConformPictures,
      completed: isStepValid(NonConformPhoto),
      visible: isStepVisible(NonConformPhoto),
    },
    {
      StepComponent: AssembledWeightCapture,
      details: "Record the assembled weight",
      value: assembledWeight,
      completed: isStepValid(AssembledWeightCapture),
      visible: isStepVisible(AssembledWeightCapture),
    },
    {
      StepComponent: ConformingWeightCapture,
      details: "Record the conforming weight",
      value: conformingWeight,
      completed: isStepValid(ConformingWeightCapture),
      visible: isStepVisible(ConformingWeightCapture),
    },
    {
      StepComponent: CaptureScaleReadingPhoto,
      details: "Take a photo of the scale reading",
      value: scaleReadingPictures,
      completed: isStepValid(CaptureScaleReadingPhoto),
      visible: isStepVisible(CaptureScaleReadingPhoto),
    },
    {
      StepComponent: Summary,
      linkText: "Review",
      title: "Negative Conforming Weight",
      details:
        "The conforming weight (excluding control weight) cannot be negative. Please check and correct the weight.",
      completed: true,
      error:
        contentWeight !== "" &&
        conformingWeight !== "" &&
        controlWeight !== "" &&
        Number(conformingWeight) - Number(controlWeight) < 0,
      visible: isStepVisible(Summary),
    },
    {
      StepComponent: Summary,
      linkText: "Review",
      title: "Negative Non-conforming Weight",
      details:
        "The non-conforming weight (excluding control weight) cannot be negative. Please check and correct the weight.",
      completed: true,
      error:
        contentWeight !== "" &&
        nonConformingWeight !== "" &&
        controlWeight !== "" &&
        Number(nonConformingWeight) < 0,
      visible: isStepVisible(Summary),
    },
    {
      StepComponent: Summary,
      linkText: "Review",
      title: "Negative Total Weight",
      details:
        "The total weight (excluding control weight) cannot be negative. Please check and correct the weight.",
      completed: true,
      error:
        contentWeight !== "" &&
        controlWeight !== "" &&
        Number(contentWeight) - Number(controlWeight) < 0,
      visible: isStepVisible(Summary),
    },
    {
      StepComponent: Summary,
      linkText: "Review",
      title: "Conforming exceeds total contents",
      details: "Review all recorded weights",
      completed: true,
      error:
        contentWeight !== "" &&
        conformingWeight !== "" &&
        controlWeight !== "" &&
        Number(conformingWeight) - Number(controlWeight) >
          Number(contentWeight) - Number(controlWeight),
      visible: isStepVisible(Summary),
    },
  ];
};
